/**
 * Post format helpers — formatos de publicação suportados.
 * Mantém em sincronia com /app/backend/mesafa/models.py (PostFormat).
 */

export const POST_FORMATS = [
    {
        id: "feed",
        label: "Feed",
        sublabel: "Publicação Instagram/Facebook",
        dimensions: "1080×1350",
        aspect: "4:5",
        aspectRatio: 4 / 5,
        aspectClass: "aspect-[4/5]",
        aiAspect: "4:5",
        description: "Recomendado para Instagram, Facebook e LinkedIn",
    },
    {
        id: "stories",
        label: "Stories",
        sublabel: "Stories / Reels / TikTok",
        dimensions: "1080×1920",
        aspect: "9:16",
        aspectRatio: 9 / 16,
        aspectClass: "aspect-[9/16]",
        aiAspect: "9:16",
        description: "Recomendado para Stories, Reels, TikTok e YouTube Shorts",
    },
    {
        id: "quadrado",
        label: "Quadrado",
        sublabel: "Imagem 1:1",
        dimensions: "1080×1080",
        aspect: "1:1",
        aspectRatio: 1,
        aspectClass: "aspect-square",
        aiAspect: "1:1",
        description: "Formato clássico, compatível com todos os canais",
    },
];

export const DEFAULT_POST_FORMAT = "feed";

export function getPostFormat(formatId) {
    return POST_FORMATS.find((f) => f.id === formatId) || POST_FORMATS[0];
}

// Limites de upload (tamanhos em bytes)
export const MAX_IMAGE_BYTES = 10 * 1024 * 1024; // 10 MB
export const MAX_VIDEO_BYTES = 25 * 1024 * 1024; // 25 MB
export const ACCEPTED_IMAGE_TYPES = ["image/jpeg", "image/jpg", "image/png", "image/webp"];
export const ACCEPTED_VIDEO_TYPES = ["video/mp4", "video/webm", "video/quicktime", "video/x-m4v"];

export function detectMediaType(file) {
    if (!file) return null;
    if (ACCEPTED_IMAGE_TYPES.includes(file.type)) return "image";
    if (ACCEPTED_VIDEO_TYPES.includes(file.type) || file.type.startsWith("video/")) return "video";
    return null;
}

export function validateMediaFile(file) {
    const kind = detectMediaType(file);
    if (!kind) {
        return { ok: false, message: "Formato não suportado. Use JPG/PNG/WEBP ou MP4/MOV/WEBM." };
    }
    const limit = kind === "image" ? MAX_IMAGE_BYTES : MAX_VIDEO_BYTES;
    if (file.size > limit) {
        const mb = Math.round(limit / (1024 * 1024));
        return { ok: false, message: `${kind === "image" ? "Imagem" : "Vídeo"} demasiado grande (máx ${mb} MB).` };
    }
    return { ok: true, kind };
}

export function readFileAsDataUrl(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}
